import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Match from "./Match";
import gameTime from "../../../../functions/gameTime";
import { useTournament } from "../../TournamentContext";

const Day = ({
  dayId,
  numberOfDays,
  matchIds,
  startTime,
  gameLength,
  interval,
  numberOfCourts,
  scheduleType,
}) => {
  const { matches, tournament } = useTournament();

  const { setNodeRef } = useDroppable({
    dayId,
  });

  const title =
    scheduleType === "swissRounds"
      ? `Round ${Number(dayId) + 1}`
      : `Day ${Number(dayId) + 1}`;

  return (
    <div
      key={dayId}
      data-testid={`schedule-day-${dayId}`}
      className="w-full max-w-lg bg-white shadow-xl rounded-xl overflow-hidden border border-stone-300 h-full"
    >
      <div className="bg-slate-400 p-3 relative">
        <h3 className="text-xl font-bold text-white text-center">{title}</h3>
      </div>

      <SortableContext
        id={dayId}
        items={matchIds}
        strategy={verticalListSortingStrategy}
      >
        <div ref={setNodeRef}>
          {matchIds.map((matchId, index) => {
            const displayGameTime = gameTime(
              index,
              startTime,
              gameLength,
              interval,
              numberOfCourts
            );

            const match =
              matchId === "break"
                ? {
                    team1Id: "",
                    team2Id: "",
                    team1Score: null,
                    team2Score: null,
                  }
                : matches[matchId];

            return (
              <Match
                key={matchId}
                matchIndex={index}
                matchId={matchId}
                match={match}
                dayId={dayId}
                gameTime={displayGameTime}
                numberOfCourts={numberOfCourts}
                disabled={
                  (scheduleType === "swissRounds" &&
                    Number(dayId) !== numberOfDays - 1) ||
                  tournament?.bracket
                }
              />
            );
          })}
        </div>
      </SortableContext>
    </div>
  );
};

export default Day;
